import script from "./AdminEditVehicleModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminEditVehicleModal.vue?vue&type=script&setup=true&lang=ts"

import "./AdminEditVehicleModal.vue?vue&type=style&index=0&id=69ec5db8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69ec5db8"]])

export default __exports__